// extracted by mini-css-extract-plugin
export var divider = "_g1-7";
export var itemsToggle = "_g1-8";
export var mergeModal = "_g1-1";
export var optionCard = "_g1-4";
export var radioGroup = "_g1-6";
export var radioOption = "_g1-0";
export var selected = "_g1-5";
export var shipmentOptions = "_g1-2";
export var tableOptions = "_g1-3";